var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useUniqID } from '../_internal/useUniqId';
import { LabelContainer, FieldWithLabelContainer, LabelElementRightContainer, } from './withLabel.style';
export var withLabel = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.padding, padding = _c === void 0 ? 'small' : _c, _d = _b.orientation, orientation = _d === void 0 ? 'vertical' : _d, _e = _b.type, defaultLabelType = _e === void 0 ? 'small' : _e, componentName = _b.componentName;
    return function (WrappedComponent) {
        var Field = React.forwardRef(function (props, ref) {
            var _a = props, label = _a.label, _b = _a.labelType, labelType = _b === void 0 ? defaultLabelType : _b, labelElementRight = _a.labelElementRight, rawId = _a.id, rest = __rest(_a, ["label", "labelType", "labelElementRight", "id"]);
            var id = useUniqID(rawId);
            if (label) {
                return (React.createElement(FieldWithLabelContainer, { className: "label-line", "data-orientation": orientation, "data-padding": padding },
                    React.createElement(LabelContainer, { "data-type": labelType, "data-disabled": rest.disabled, "data-testid": "".concat(componentName !== null && componentName !== void 0 ? componentName : 'input', "-label"), "data-error": rest.error, htmlFor: id },
                        label,
                        React.createElement(LabelElementRightContainer, null, labelElementRight)),
                    React.createElement(WrappedComponent, __assign({}, rest, { ref: ref, id: id }))));
            }
            return React.createElement(WrappedComponent, __assign({}, rest, { ref: ref }));
        });
        return Field;
    };
};
//# sourceMappingURL=withLabel.js.map